import { Equipment } from './equipment';

export class Reshuffle {
    Demand: Equipment;
    Supply: Equipment;
}
